import { createContext, useContext } from 'react';

const StagingContext = createContext<boolean>(false);

export const useStaging = () => useContext(StagingContext);

export function StagingProvider({
    children,
    isStaging = false,
}: {
    children: React.ReactNode;
    isStaging?: boolean;
}) {
    return (
        <StagingContext.Provider value={isStaging}>{children}</StagingContext.Provider>
    );
}
